module.exports = __webpack_public_path__ + "img/67_1.4ed9e01f.jpg";